const styles = (theme) => ({
  container: {
    width: "900px",
    borderRadius: "16px",
    maxWidth: "80vw",
  },
  containerForm: {
    padding: "20px",
    display: "flex",
    flexDirection: "column",
    gap: 1.2,
  },
  textfield: {
    //margin: "5px 0px",
  },
  containerTitulo: {
    p: 2,
    pb: "4px",
    display: "flex",
    justifyContent: "space-between",
  },
  buttonCancel: {
    color: "secondary.main",
  },
  containerButtons: {
    padding: "10px",
    width: "100%",
    display: "flex",
    justifyContent: "end",
  },
  chipPermissao: {
    fontWeight: "bold",
    maxWidth: "100%", // Limita o tamanho no seletor
    "& .MuiChip-label": {
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    },
  },
  menuItemPermissao: {
    maxWidth: "400px",
    display: "flex",
    justifyContent: "flex-start",
  },
  chipMenuItemPermissao: {
    cursor: "pointer", // Mantém o feedback visual de clique
    maxWidth: "100%",
    "& .MuiChip-label": {
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    },
  },
  paperDatagrid: {
    width: "100%",
    overflowX: "auto",

    borderRadius: "16px",
    height: "200px",
  },
  boxClientesPermitidos: {
    display: "flex",
    flexDirection: "column",
    gap: 2,
    width: "100%",
  },
  containerClientesPermitidos: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-end",
    flexWrap: "wrap",
    gap: 2,
  },
  titleClientesPermitidos: { display: "flex", gap: 0.5, alignItems: "center" },
});

export default styles;
